<div class="modal-header" *ngIf="!loading">
    <h2 class="modal-title" mat-dialog-title *ngIf="updating" trans>Update Project</h2>
    <h2 class="modal-title" mat-dialog-title *ngIf="!updating" trans>Create Project</h2>
    <button type="button" (click)="close()" class="close-button" mat-icon-button tabindex="-1">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<form autocomplete="off" (ngSubmit)="confirm()" ngNativeValidate>
    <mat-dialog-content class="many-inputs">
        <ng-container *ngIf="!loading;else elseSection">
            <div class="input-container">
                <label for="name" trans>Name</label>
                <input type="text" id="name" name="name" [(ngModel)]="model.name" minlength="3" required>
                <div class="error" *ngIf="errors.slug">{{errors.slug}}</div>
            </div>
            <div class="input-container" *ngIf="data.useS3Field">
                <label for="s3_destination_url" trans>S3 Url</label>
                <input type="text" id="s3_destination_url" name="s3_destination_url" [(ngModel)]="model.s3_destination_url" required>
                <div class="error" *ngIf="errors.s3_destination_url">{{errors.s3_destination_url}}</div>
            </div>
    
            <ng-container *ngIf="data.showExtraConfig">
                <div class="input-container">
                    <select-user-input [(ngModel)]="model.users[0]" name="project-owner"></select-user-input>
                </div>
    
                <div class="input-container">
                    <label for="template" trans>Template</label>
                    <select id="template" name="template" [(ngModel)]="model.template">
                        <option [ngValue]="null" trans>None</option>
                        <option [ngValue]="template.name" *ngFor="let template of templates">{{template.config?.name || template.name}}</option>
                    </select>
                    <div class="error" *ngIf="errors.template">{{errors.template}}</div>
                </div>
    
                <div class="input-container">
                    <label for="published" trans>Published</label>
                    <select id="published" name="published" [(ngModel)]="model.published">
                        <option [ngValue]="true" trans>Yes</option>
                        <option [ngValue]="false" trans>No</option>
                    </select>
                    <div class="error" *ngIf="errors.published">{{errors.published}}</div>
                </div>
            </ng-container>
        </ng-container>
        <ng-template #elseSection>
            <div class="row justify-content-center">

                <!-- <mat-progress-spinner
                  mode="indeterminate"
                  color="accent"
                  [diameter]="80"
                ></mat-progress-spinner> -->
                <div class="loader-box-container">
                    <div class="loader-box">
                      <div class="lds-grid">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                    <div class="loader-text" trans>Loading</div>
                  </div>
                  
            </div>
        </ng-template>
        
        
    </mat-dialog-content>

    <mat-dialog-actions class="buttons right" *ngIf="!loading">
        <button (click)="close()" type="button" mat-button class="cancel-button" trans>Cancel</button>
        <button type="submit" class="button primary" mat-raised-button color="accent" [disabled]="loading">
            <span *ngIf="updating" trans>Update</span>
            <span *ngIf="!updating" trans>Create</span>
        </button>
    </mat-dialog-actions>
</form>
